import { useState } from 'react';
import { formatOrderTicket, type OrderTicket } from '@/lib/formatOrderTicket';
import toast from 'react-hot-toast';

interface CopyOrderButtonProps {
  order: OrderTicket;
  className?: string;
}

export function CopyOrderButton({ order, className }: CopyOrderButtonProps) {
  const [copied, setCopied] = useState(false);

  async function handleCopy() {
    const text = formatOrderTicket(order);
    try {
      await navigator.clipboard.writeText(text);
      setCopied(true);
      toast.success('Order copied');
      setTimeout(() => setCopied(false), 1500);
    } catch {
      toast.error('Could not copy');
    }
  }

  return (
    <button
      type="button"
      onClick={handleCopy}
      className={`text-xs text-blue-600 hover:text-blue-800 underline ${className ?? ''}`}
      title="Copy order details to clipboard"
    >
      {copied ? 'Copied' : 'Copy'}
    </button>
  );
}
